import styled from 'styled-components';

import { COLORS } from 'styles/constants';

export const Container = styled.div`
  background: #fff;

  display: flex;
  flex-direction: column;
`;

export const ReviewHeader = styled.div`
  margin-bottom: 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    width: 90%;
    display: flex;
    align-items: center;
  }

  svg {
    color: ${COLORS.primary};
    cursor: pointer;
  }

  svg:hover {
    color: ${COLORS.darktext};
  }

  @media only screen and (max-width: 900px) {
    align-items: flex-start;

    > div {
      align-items: flex-start;
      flex-direction: column;
    }
  }
`;

export const ReviewAuthor = styled.input`
  min-width: 300px;
  padding: 10px;
  margin-right: 15px;

  @media only screen and (max-width: 900px) {
    min-width: 10px;
    max-width: 75%;
    margin-bottom: 20px;
  }
`;

export const ReviewVeredict = styled.input`
  margin-left: 5px;
  transform: scale(1.5);
`;

export const ReviewMessage = styled.textarea`
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 100px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px;
`;
